export default "__VITE_ASSET__CdPvOTDu__"